import { ProgressBar } from '../../custom-components/ProgressBar';
import { ReviewProgressSteps } from '../../custom-components/ReviewProgressSteps';
import type { MatchRunProgress as Progress } from '../../hooks/useMatchRun';

const STEPS: { key: 'FETCHING' | 'MATCHING' | 'FINALIZING'; label: string }[] = [
  { key: 'FETCHING', label: 'Reading companies from HubSpot' },
  { key: 'MATCHING', label: 'Matching companies to institutions' },
  { key: 'FINALIZING', label: 'Finalizing' },
];

interface MatchRunProgressProps {
  status?: string;
  progress: Progress;
  nrCompaniesFetched?: number | null;
  nrCompaniesTotal?: number | null;
  nrCompaniesMatched?: number | null;
}

export function MatchRunProgress({
  status,
  progress,
  nrCompaniesFetched,
  nrCompaniesTotal,
  nrCompaniesMatched,
}: MatchRunProgressProps) {
  // Live events lead the persisted counters, but the persisted ones survive a reload.
  const step = progress.step ?? (status === 'MATCHING' ? 'MATCHING' : 'FETCHING');

  const fetched = progress.processed ?? nrCompaniesFetched ?? 0;
  const total = progress.total ?? nrCompaniesTotal ?? 0;
  const matched = progress.matched ?? nrCompaniesMatched ?? 0;

  return (
    <div style={{ marginTop: 40, marginBottom: 40 }}>
      {/* The count leads: it is the part that moves, and it answers how far along the run
          is before the steps say what it is doing. */}
      <div style={{ fontSize: 24, fontWeight: 600 }}>
        {step === 'FETCHING'
          ? `${fetched.toLocaleString()} companies read`
          : `${matched.toLocaleString()} of ${total.toLocaleString()} matched`}
      </div>

      {/* Only during matching: the account's size is unknown until reading finishes, so a
          bar before then would be measuring against a total we do not have. */}
      {step === 'MATCHING' && total > 0 && (
        <ProgressBar value={matched} max={total} style={{ marginTop: 10 }} />
      )}

      {/* The same component the export wizard's review and export steps use, so a run and
          the export it hands over to do not draw progress two different ways. */}
      <ReviewProgressSteps steps={STEPS} currentStep={step} />
    </div>
  );
}
